var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 19" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M21 .2H0l8.6 11.1-.2 5 3.4 2.5.1-7.4z" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M18.4 14.8l2.3-2.3c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3-2.3-2.3c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l2.3 2.3-2.3 2.3c-.3.3-.3.8 0 1.1.3.3.8.3 1.1 0l2.3-2.3 2.3 2.3c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1l-2.3-2.3z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/RemoveFilter.svg